<div class="epod-container">
  <!-- Loading State -->
  <div *ngIf="loading" class="loading-container">
    <div class="spinner"></div>
    <p>Downloading document...</p>
  </div>

  <!-- Success State -->
  <div *ngIf="success && !loading" class="success-container">
    <div class="success-icon">✓</div>
    <p class="success-message">Document downloaded</p>
  </div>

  <!-- Error State -->
  <div *ngIf="error && !loading && !success" class="error-container">
    <div class="error-icon">⚠️</div>
    <p class="error-message">{{ error }}</p>
  </div>
</div>

